import { atom } from 'jotai';

import { DemandEventTableItem } from '@/features/demand-events/demand-events.types';

export const selectedEventAtom = atom<DemandEventTableItem | null>(null);

selectedEventAtom.debugLabel = 'DemandEventDrawerState.selectedEventAtom';
